<template>
  <div class="w-full">
    <studio-email-editor
      ref="studioEditor"
      :value="editorContent || ''"
      :html-mode="false"
      :restricted="Boolean(editorWithBlockedLinkRestriction)"
      :dynamic-variables="editorDynamicVariables"
      :allow-preview="allowEditorPreview"
      :allow-html="allowEditorHtmlView"
      :opened-from="openedFrom"
      :editor-node-with-no-margin="editorNodeWithNoMargin"
      @input="$emit('editorContentUpdated', $event)"
      @template-selected="$emit('templateSelected', $event)"
      @showLoader="$emit('showLoader')"
      @hideLoader="$emit('hideLoader')"
    />
  </div>
</template>

<script>
import StudioEmailEditor from '../features/studio/StudioEmailEditor.vue';
import { readEditorContent } from './emailContentValidation';

// This component remains the compatibility boundary used by campaigns,
// forms, sequences, and admin settings. The active editor is now the single
// TipTap based Standard Rich Text Email Editor; callers keep their existing
// props and events.
export default {
  name: 'emailBasicEditor',
  components: { StudioEmailEditor },
  props: {
    editorOptions: { required: true },
    editorContent: { required: true },
    editorNodeWithNoMargin: { required: true },
    editorWithBlockedLinkRestriction: { required: true },
    editorDynamicVariables: { required: true },
    openedFrom: { required: true },
    allowEditorPreview: { required: false },
    allowEditorHtmlView: { required: false },
    editorClasses: { required: false },
    currentEditorView: { required: false }
  },
  methods: {
    handleImageInsertionInContent() {
      const studio = this.$refs && this.$refs.studioEditor;
      return studio && typeof studio.handleImageInsertionInContent === 'function'
        ? studio.handleImageInsertionInContent()
        : false;
    },
    // Public content API. Parents must use this instead of walking $refs:
    // the mounted editor is TipTap (studioEditor), and the old Quill ref is absent.
    getPlainText() {
      const reading = readEditorContent(this, { skipOwnMethods: true });
      return reading.available ? reading.text : null;
    },
    getHtml() {
      const reading = readEditorContent(this, { skipOwnMethods: true });
      return reading.available ? reading.html : null;
    }
  }
};
</script>
